import React, { useState } from "react";
import { Dropdown, Menu,Input } from "antd";
import MenuItem from "antd/lib/menu/MenuItem";
import { getLocations, getDatabase } from "../../Table";
import { Search } from "../Search";
import "./Filter.css";
var locationData = getLocations(),
  listLength = locationData.length,
  rowArray = getDatabase();

export const Filter = () => {
  const [selection, updateSelection] = useState("");
  var t = () => {
    var selectedRows = [];
    for (var j = 0; j < listLength; j++) {
      if (selection === locationData[j]) {
        selectedRows.push(j);
      }
    }
    var filterResults = [];
    filterResults.push(rowArray[0]);
    for (var k = 0; k < selectedRows.length; k++) {
      filterResults.push(rowArray[selectedRows[k] + 1]);
    }
    return filterResults;
  };
  return (
    <div>
      <div>
        <Dropdown
          overlay={
            <Menu
              onSelect={(item) => {
                              updateSelection(item.key);
                              
              }}
              selectable
              id="filterMenu"
            >
              <MenuItem className="choice" key="US">
                US
              </MenuItem>
              
              <MenuItem className="choice" key="CA">
                CA
              </MenuItem>
              <MenuItem className="choice" key="UK">
                              UK
              </MenuItem>
              <MenuItem className="choice" key="FR">
                              FR
              </MenuItem>
               <MenuItem className="choice" key="AU">
                              AU
              </MenuItem>
               <MenuItem className="choice" key="TW">
                              TW
              </MenuItem>
               <MenuItem className="choice" key="GB">
                              GB
              </MenuItem>
               <MenuItem className="choice" key="PA">
                              PA
              </MenuItem>
               <MenuItem className="choice" key="IN">
                              IN
              </MenuItem>
               <MenuItem className="choice" key="IE">
                              IE
              </MenuItem>
                          <MenuItem className="choice" key="JP">
                              JP
              </MenuItem>
            </Menu>
          }
        >
          <button id="filter">Filter By Region</button>
        </Dropdown>
      </div>
      <div className="filterContainer">
        {selection === "" ? (
          <Search  />
              ) : (
                      
                      <span>
                      <div className="filterOptions">
                          {t()}
                          
                          </div>
                          <Input.Search
                              style={{ width: "54%" }}
                              className="searchField"
                              id="searchField"
                              // onSearch={() =>
                              //   updateUserInput(document.getElementById("searchField").value)
                              // }
                              disabled
                              placeholder="Clear filter to use search bar :) "
                          />  
                          <div id="pageNav">
                              <button
                                  id="Button1"
                                  className="pageNav"
                                  disabled
                                  color="#96baff"
                              >
                                  1
                              </button>
                              <button
                                  id="Button2"
                                  className="pageNav"
                                  color="#96baff"
                                  disabled
                              >
                                  2
                              </button>
                              <button
                                  id="Button3"
                                  className="pageNav"
                                  color="#96baff"
                                  disabled
                              >
                                  3
                                </button>
                              <button
                                  id="Button4"
                                  className="pageNav"
                                  color="#96baff"
                                  disabled
                              >
                                  4
        </button>
                              <button
                                  id="Button5"
                                  className="pageNav"
                                  color="#96baff"

                                  disabled
                              >
                                  5
        </button>
                          </div>
                      </span>
        )}
        {selection === "" ? null : (
          <button id="clearFilter" onClick={() => updateSelection("")}>
            Clear Filter
          </button>
        )}
      </div>
    </div>
  );
};
